export const routesList = {
  DEFAULT: {
    title: 'Welcome to FedSimX',
    path: '/setup'
  },
  START: {
    title: 'Start Game',
    path: '/start'
  },
  IMPORT: {
    title: 'Import',
    path: '/import/:groupName'
  },
  HELP: {
    title: 'Help',
    path: '/help'
  },
  SIMULATE: {
    title: 'Simulate',
    path: '/simulate'
  },
  DRAFT: {
    title: 'Draft',
    path: '/draft/*',
    stripAsterisk: true
  },
  DIALOG: {
    title: 'Dialog',
    path: '/dialog/*',
    stripAsterisk: true
  },
  OFFICE: {
    title: 'Office',
    path: '/office'
  },
  BRANDS: {
    title: 'Brands',
    path: '/brands/*',
    stripAsterisk: true
  },
  QUICKMODE: {
    title: 'QuickMode',
    path: '/quick-mode/:id',
    stripAsterisk: true
  },
  CREATE_SHOW: {
    title: 'Create Show',
    path: '/create-show/:showId/:date',
    hidden: true,
    stripAsterisk: true
  },
  DASHBOARD: {
    title: 'CMS',
    path: '/dashboard/*'
  },
  ALIGNMENT: {
    title: 'Alignment',
    path: '/alignment'
  },
  MATCH: {
    title: 'Match',
    path: '/match/*'
  },
  PRODUCTION: {
    title: 'Production',
    path: '/production/*',
    stripAsterisk: true
  },
  SETUP: {
    title: 'Setup',
    path: '/setup/*',
    stripAsterisk: true
  },
  PRODUCTION_SELECT: {
    title: 'Production',
    path: '/production/select'
  },
  BLOG: {
    title: 'Blog',
    path: '/blog',
  },
  MIGRATIONS: {
    title: 'Migrations',
    path: '/migrations',
  },
  SETTINGS: {
    title: 'Settings',
    path: '/settings'
  },
  DS: {
    title: 'Design System',
    path: '/ds'
  },
  ARENAS: {
    title: 'Arenas',
    path: '/arenas'
  },
  LEAGUES: {
    title: 'Leagues',
    path: '/leagues'
  },
  FEUDS: {
    title: 'Feuds',
    path: '/feuds'
  },
  REIGNS: {
    title: 'Reigns',
    path: '/reigns'
  },
  FEUDS_PLANNER: {
    title: 'Feuds',
    path: '/feuds-planner'
  }
}

export const routesKeys = Object.keys(routesList)
